<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
    <v-container class="text-center">
      <v-row>
        <v-col cols="12">
          <v-text-field
            filled
            data-cy="FormJobListingStatus-name"
            :label="$$t('name')"
            v-model="localJobListingStatus.name"
          />
        </v-col>
      </v-row>
      <div class="d-flex justify-end mb-6">
        <v-btn
          color="default"
          outlined
          class="ml-4 btn-cancel"
          @click="cancel"
          data-cy="FormJobListingStatus-button-cancel">
          {{ $t('common.buttons.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          type="submit"
          class="ml-4"
          :loading="isSaving"
          data-cy="FormJobListingStatus-button-save">
          {{ $t('common.buttons.save') }}
        </v-btn>
      </div>
    </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'FormJobListingStatus',
  module: 'Clients',
  mixins: [loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    JobListingStatus: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localJobListingStatus
      */
      localJobListingStatus: {},
    };
  },
  watch: {
    JobListingStatus() {
      this.localJobListingStatus = this.JobListingStatus;
    },
  },
  created() {
    this.localJobListingStatus = this.JobListingStatus;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localJobListingStatus);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormJobListingStatus example

'''js
<FormJobListingStatus :JobListingStatus="JobListingStatus" />
'''
</docs>
